import { temporal } from "zundo";
import { create } from "zustand";

export const initialState = {
  isNormalized: false,
  cameraInitialPosition: [0, 2, 7],
  dataFromProps: null,
  isImage: false,
  isSceneLoaded: false,
  isCanvasReady: false,
  humanScale: true,
  isSaving: false,
  initialPositionVector: [0, 0, 0],

  modelUrl: null,
  customPosition: {
    position: [0, 0, 0],
    rotation: [0, 0, 0],
    scale: 1,
  },
  animation: 0,
  molding: "",
  socle: false,
  socleColor: { r: 211, g: 175, b: 95, a: 0.13 },
  startGrid: 0,
  endGrid: 0,
  regeneratePreview: false,
};

const useThreeJsLoader = create(
  temporal((set) => ({
    ...initialState,
    setCanvasReady: (value = true) => set(() => ({ isCanvasReady: value })),
    setIsSaving: () => set(() => ({ isSaving: true })),
    setInitialPositionVector: (pos) =>
      set(() => ({ initialPositionVector: pos })),
    setCustomPositions: (pos) =>
      set((state) => {
        return {
          customPosition: {
            ...state.customPosition,
            position: pos,
          },
        };
      }),
    setRegeneratePreview: (v) => set(() => ({ regeneratePreview: v })),
    setMolding: (mold) =>
      set(() => ({
        molding: mold,
      })),
    setCustomRotations: (rot) =>
      set((state) => {
        return {
          customPosition: {
            ...state.customPosition,
            rotation: rot,
          },
        };
      }),
    setRotationAnim: (rot) =>
      set(() => {
        return {
          animation: rot,
        };
      }),
    setCustomScale: (scale) => {
      return set((state) => {
        return {
          customPosition: {
            ...state.customPosition,
            scale,
          },
        };
      });
    },
    setSocleColor: (color) =>
      set(() => {
        return {
          socleColor: color,
        };
      }),
    toggleSocle: () =>
      set((state) => {
        return {
          socle: !state.socle,
          customPosition: {
            ...state.customPosition,
            position: !state.socle
              ? [
                  state.customPosition.position[0],
                  state.customPosition.position[1] + 1,
                  state.customPosition.position[2],
                ]
              : [
                  state.customPosition.position[0],
                  state.customPosition.position[1] - 1,
                  state.customPosition.position[2],
                ],
          },
        };
      }),
    setCameraPosition: (position) =>
      set(() => ({
        cameraInitialPosition: position,
      })),
    resetCameraPosition: () =>
      set(() => ({
        cameraPosition: [0, 3, 5],
      })),
    setNormalize: (value = true) => {
      return set(() => ({
        isNormalized: value,
      }));
    },
    setSceneIsLoaded: (value = true) => {
      set(() => ({
        isSceneLoaded: value,
      }));
    },
    setSceneIsNotLoaded: () =>
      set(() => ({
        isSceneLoaded: false,
      })),
    setReinitialize: () => set(() => initialState),
    toggleHumanScale: () =>
      set((state) => ({
        humanScale: !state.humanScale,
      })),
    setStateFromProps: (props) => {
      const { isNormalized, ...all } = props;
      return set(() => {
        return {
          ...all,
          dataFromProps: { ...all, isNormalized },
        };
      });
    },
    setStartGrid: (pos) => {
      set(() => ({
        startGrid: pos,
      }));
    },
    setEndGrid: (pos) => {
      set(() => ({
        endGrid: pos,
      }));
    },
  }))
);

export default useThreeJsLoader;
